// TODO: From App New
<template>
  <div class="card shadow-none rounded-lg mb-50">
    <div class="card-body py-0 px-0">
      <div class="form-row">
        <div class="col-auto d-flex flex-column align-items-center">
          <div>
            <b-avatar
              v-if="getThumbnailImage"
              :src="getThumbnailImage"
              :text="product.name.charAt(0).toUpperCase()"
              size="50px"
              variant="light-primary"
              rounded="lg"
              class="border"
            />
            <b-avatar
              v-else
              size="50px"
              variant="light-secondary"
              rounded="lg"
              class="border"
            >
              <feather-icon
                icon="ImageIcon"
                size="20"
              />
            </b-avatar>
          </div>
          <div class="mt-50 d-flex flex-column">
            <button
              v-if="isAdmin"
              class="btn btn-icon rounded-circle mb-50"
              :class="{ 'btn-success': product.is_highlighted, 'btn-flat-success': !product.is_highlighted }"
              :disabled="isSaleOngoing"
              @click="$emit('highlight-product', product)"
            >
              <feather-icon icon="TagIcon" />
            </button>
            <button
              class="btn btn-icon rounded-circle"
              :class="[
                { 'btn-warning': product.is_flagged, 'btn-flat-warning': !product.is_flagged },
                { 'mb-0': !isAdmin }
              ]"
              @click="$emit('flag-product', product)"
            >
              <feather-icon icon="FlagIcon" />
            </button>
          </div>
        </div>
        <div class="col">
          <div class="row align-items-center">
            <div class="col">
              {{ product.name }}
            </div>
            <div class="col-auto">
              <button
                class="btn btn-flat-danger btn-icon"
                :disabled="isSaleOngoing"
                @click="$emit('remove-product', product)"
              >
                <feather-icon icon="TrashIcon" />
              </button>
            </div>
          </div>

          <div class="card border mt-50 mb-2">
            <div class="card-body pt-1 px-1 pb-50">
              <div class="form-row mb-50 font-weight-light text-muted">
                <div class="col">
                  Varian
                </div>
                <div class="col-2">
                  Event
                </div>
                <div class="col-2">
                  Harga Awal
                </div>
                <div class="col-2">
                  <div>Harga Event</div>

                  <b-input-group class="input-group-merge mt-50">
                    <b-input-group-prepend>
                      <div class="input-group-text px-75 pr-50">
                        Rp
                      </div>
                    </b-input-group-prepend>
                    <b-form-input
                      :value="formatRupiah(product.sale_price_bulk)"
                      :disabled="isSaleOngoing"
                      @input="handleBulkPriceChange"
                      @keypress="handleRupiahKeyPress"
                    />
                  </b-input-group>
                </div>
                <div class="col-1 text-center">
                  <div>Disc.</div>

                  <b-input-group class="input-group-merge mt-50">
                    <b-form-input
                      :value="product.discount_percentage || 0"
                      type="number"
                      min="0"
                      max="100"
                      :disabled="isSaleOngoing"
                      @input="handleBulkDiscountChange"
                      @blur="handleSubmitBulkDiscountChange"
                      @keydown.enter.prevent="handleSubmitBulkDiscountChange"
                    />
                    <b-input-group-append>
                      <div class="input-group-text px-75 pl-50">
                        %
                      </div>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>

              <div
                v-for="(variant, variantIndex) in product.variants"
                :key="`variant-${variantIndex}`"
                class="border-top"
              >
                <div class="form-row align-items-center">
                  <div class="col">
                    <div v-if="variant.details && variant.details.length">
                      <span
                        v-for="(detail, detailIndex) in variant.details"
                        :key="`variant-${variantIndex}-detail-${detailIndex}`"
                        class="font-weight-bold"
                      ><span v-if="detailIndex > 0"> - </span>{{ detail.value }}</span>
                      <span v-if="variantIndex === 0"> (Utama)</span>
                    </div>
                    <div
                      v-else
                      class="font-weight-bold"
                    >
                      (Varian Utama)
                    </div>
                  </div>

                  <div class="col-2">
                    <b-form-checkbox
                      :checked="variant.sale_price_enabled"
                      name="check-button"
                      switch
                      inline
                      :disabled="variant.sale_price_enabled_loading || isSaleOngoing"
                      @change="handleToggleVariantSale(variant, $event)"
                    >
                      Aktif<span v-if="variant.sale_price_enabled_loading">...</span>
                    </b-form-checkbox>
                  </div>

                  <div
                    class="col-2"
                    :class="{'opacity-0': !variant.sale_price_enabled}"
                  >
                    Rp{{ variant.price | number }}
                  </div>

                  <div class="col-2 py-25">
                    <b-input-group
                      class="input-group-merge"
                      :class="{'opacity-0': !variant.sale_price_enabled}"
                    >
                      <b-input-group-prepend>
                        <div class="input-group-text px-75 pr-50">
                          <b-spinner
                            v-if="variant.sale_price_loading"
                            small
                          />
                          <span v-else>Rp</span>
                        </div>
                      </b-input-group-prepend>
                      <b-form-input
                        :value="formatRupiah(variant.sale_price)"
                        :disabled="!variant.sale_price_enabled || variant.sale_price_loading || isSaleOngoing"
                        @input="handleSalePriceInput(variant, $event)"
                        @keydown.enter.prevent="handleSubmitSalePriceChange(variant)"
                        @blur="handleSubmitSalePriceChange(variant)"
                        @keypress="handleRupiahKeyPress"
                      />
                    </b-input-group>
                  </div>

                  <div
                    class="col-1 text-center py-25"
                    :class="{'opacity-0': !variant.sale_price_enabled}"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        :value="getDiscountPercentageValue(variant)"
                        type="number"
                        min="0"
                        max="100"
                        :disabled="!variant.sale_price_enabled || variant.sale_price_loading || isSaleOngoing"
                        @input="handleDiscountInput(variant, $event)"
                        @blur="handleSubmitDiscountChange(variant)"
                        @keydown.enter.prevent="handleSubmitDiscountChange(variant)"
                      />
                      <b-input-group-append>
                        <div class="input-group-text px-75 pl-50">
                          <b-spinner
                            v-if="variant.discount_loading"
                            small
                          />
                          <span v-else>%</span>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormInput,
  BFormCheckbox,
  BSpinner,
  BAvatar,
} from 'bootstrap-vue'
import { formatRupiah, parseRupiahValue, handleRupiahKeyPress } from '@/helper/rupiah'

export default {
  name: 'SaleProductCard',
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormInput,
    BFormCheckbox,
    BSpinner,
    BAvatar,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isSaleOngoing: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'flag-product',
    'highlight-product',
    'remove-product',
    'bulk-price-change',
    'sale-price-change',
    'toggle-variant-sale',
    'submit-sale-price-change',
    'bulk-discount-change',
    'discount-change',
    'submit-discount-change',
    'submit-bulk-discount-change',
  ],
  data() {
    return {}
  },
  computed: {
    getThumbnailImage() {
      if (this.product.images && this.product.images.length > 0) {
        return this.$options.filters.thumbnail(this.product.images[0].image_url, 50)
      }
      return null
    },
  },
  methods: {
    handleBulkPriceChange(value) {
      // Remove formatting and get numeric value
      const numericValue = parseRupiahValue(value)
      this.$emit('bulk-price-change', this.product, numericValue)
    },

    handleSalePriceInput(variant, value) {
      // Remove formatting and get numeric value
      const numericValue = parseRupiahValue(value)
      this.$emit('sale-price-change', this.product, variant, numericValue)
    },

    handleToggleVariantSale(variant, enabled) {
      this.$emit('toggle-variant-sale', variant, enabled)
    },

    handleSubmitSalePriceChange(variant) {
      this.$emit('submit-sale-price-change', variant)
    },

    handleBulkDiscountChange(value) {
      const discountValue = Math.min(Math.max(parseFloat(value) || 0, 0), 100)
      this.$emit('bulk-discount-change', this.product, discountValue)
    },

    handleSubmitBulkDiscountChange() {
      this.$emit('submit-bulk-discount-change', this.product)
    },

    handleDiscountInput(variant, value) {
      const discountValue = Math.min(Math.max(parseFloat(value) || 0, 0), 100)
      this.$emit('discount-change', this.product, variant, discountValue)
    },

    handleSubmitDiscountChange(variant) {
      this.$emit('submit-discount-change', variant)
    },

    getDiscountPercentageValue(variant) {
      if (variant.discount_percentage) return variant.discount_percentage
      if (variant.sale_price === null || variant.sale_price === undefined || variant.sale_price === '') return 0
      if (!variant.price) return 0

      return Math.round(((variant.price - variant.sale_price) / variant.price) * 100)
    },

    // Use helper methods
    formatRupiah,
    handleRupiahKeyPress,
  },
}
</script>

<style scoped>
/* Hide number input arrows/spinners */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
